/* Printavelle instant navigation.
   Warms up the next page as soon as a visitor points at or touches a link, so
   the page is already on its way before the click lands. Purely additive: it
   never changes what a link does, and it stays out of the way on slow or
   metered connections. */
(function () {
  var conn = navigator.connection || {};
  if (conn.saveData) return;
  if (typeof conn.effectiveType === 'string' && /2g/.test(conn.effectiveType)) return;

  var seen = new Set();
  var budget = 12; // never warm up more than a dozen pages per visit
  var origin = window.location.origin;

  function eligible(a) {
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return false;
    if (a.dataset.pvNoPrefetch !== undefined) return false;
    var href = a.href;
    if (!href || href.indexOf(origin) !== 0) return false;
    if (href.indexOf('#') === 0) return false;
    var path = a.pathname || '';
    // Skip anything that changes state or is never cacheable.
    if (/\/(cart|checkouts?|account|apps|tools)(\/|$)/.test(path)) return false;
    if (href === window.location.href) return false;
    return true;
  }

  function warm(a) {
    if (budget <= 0) return;
    if (!eligible(a)) return;
    var href = a.href.split('#')[0];
    if (seen.has(href)) return;
    seen.add(href);
    budget--;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = href;
    document.head.appendChild(link);
  }

  function fromEvent(event) {
    var a = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (a) warm(a);
  }

  var timer = null;
  document.addEventListener(
    'pointerover',
    function (event) {
      if (event.pointerType === 'touch') return;
      var a = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!a) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        warm(a);
      }, 65);
    },
    { passive: true },
  );
  document.addEventListener('pointerout', function () {
    clearTimeout(timer);
  }, { passive: true });
  document.addEventListener('touchstart', fromEvent, { passive: true });
})();
